// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OF-ZR","col":"styles_col__2WgpO","actions":"styles_actions__3LOuM","conflict":"styles_conflict__2e9bf"};